<template>
    <div :class="horizontal ? 'd-flex flex-row' : ''">
        <label v-if="!withoutLabel" class="w-100"
               :class="horizontal && !noLabelWidthRate ? 'col-' + labelWidthRate : ''">
            {{ $t(config.label) }}
            <span v-if="visible" class="text-danger">*</span>
            :
        </label>
        <div class="d-flex flex-row" :class="horizontal && !noLabelWidthRate ? 'col-' + (12 - labelWidthRate) : ''">
            <b-form-input v-if="isType(VALUE_TYPE.INPUT)"
                          ref="myInput"
                          v-model="tempValue"
                          :state="true2Null(validation)"
                          :type="config.format ? config.format : 'text'"
                          debounce="500"
                          @keydown.enter="emitEnterEvent"
                          @focus.native="emitFocusEvent"
                          @blur="hasChanged">
            </b-form-input>
            <b-form-select v-else-if="isType(VALUE_TYPE.SELECT)"
                           ref="myInput"
                           v-model="tempValue"
                           :state="true2Null(validation)"
                           :options="options"
                           @keydown.enter="emitEnterEvent"
                           @focus.native="emitFocusEvent"
                           @input="hasChanged">
            </b-form-select>
            <b-form-textarea v-else-if="isType(VALUE_TYPE.TEXTAREA)"
                             ref="myInput"
                             v-model="tempValue"
                             :state="true2Null(validation)"
                             :plaintext="config.plaintext"
                             debounce="500"
                             rows="3"
                             @keydown.enter="emitEnterEvent"
                             @focus="emitFocusEvent"
                             @blur="hasChanged">
            </b-form-textarea>
            <b-form-checkbox v-else-if="isType(VALUE_TYPE.CHECKBOX)"
                             class="m-auto"
                             v-model="tempValue"
                             :disabled="disabled"
                             @input="hasChanged">
            </b-form-checkbox>
            <b-form-datepicker v-else-if="isType(VALUE_TYPE.DATE) || isType(VALUE_TYPE.DATETIME)"
                               v-model="tempValue"
                               placeholder="Date"
                               boundary="window"
                               :class="isType(VALUE_TYPE.DATETIME) ? 'col-8' : ''"
                               class="time-cover"
                               :state="true2Null(validation)"
                               :reset-button="config.resetAble"
                               @input="hasChanged">
            </b-form-datepicker>
            <b-form-timepicker v-if="isType(VALUE_TYPE.DATETIME)"
                               v-model="tempTime"
                               :hour12="false"
                               now-button boundary="window"
                               :class="isType(VALUE_TYPE.DATETIME) ? 'col-4 ml-1' : ''"
                               class="time-cover"
                               placeholder="Time"
                               :state="true2Null(validation)"
                               @input="hasChanged">
            </b-form-timepicker>
            <mini-multi-select v-if="isType(VALUE_TYPE.SELECT_MULTI)"
                               :value.sync="tempValue"
                               :options="getMultiSelectOptions()"
                               :state="true2Null(validation)"
                               @blur="hasChanged">
            </mini-multi-select>
            <el-date-picker v-if="isType(VALUE_TYPE.DATE_RANGE)"
                            v-model="tempValue" size="mini"
                            type="datetimerange">
            </el-date-picker>
            <b-form-radio-group v-if="isType(VALUE_TYPE.RADIO_SELECT)"
                                v-model="tempValue"
                                :options="options">
            </b-form-radio-group>
            <image-upload v-if="isType(VALUE_TYPE.IMAGE)"
                          :action="action" auto-upload
                          :ids="tempValue"
                          @idsChange="whenUploadSuccess"></image-upload>
            <multi-attachment v-if="isType(VALUE_TYPE.ATTACHMENT)"
                              class="w-100"
                              :attachment-ids="tempValue"
                              @idsChanged="whenAttachmentChange"></multi-attachment>
            <div v-if="isType(VALUE_TYPE.ENTITY_ID)" class="w-100 position-relative">
                <b-form-input v-model="tempValue"
                              :state="true2Null(validation)"
                              disabled>
                </b-form-input>
                <div class="position-absolute top left right bottom" @click="$refs.entityPick.showModal()"></div>

                <QgEntityPick ref="entityPick" :config-code="config.entityFrom"
                              @selected="tempValue=$event[config.entityFromByKey || 'id']"></QgEntityPick>
            </div>
        </div>

        <div v-if="invalidShow">
            <b-form-invalid-feedback :state="false">
                {{ invalidShow }}
            </b-form-invalid-feedback>
        </div>
        <div v-else-if="(config.validation !== undefined || require) && changed">
            <b-form-valid-feedback :state="validation">
                {{ valid }}
            </b-form-valid-feedback>
            <b-form-invalid-feedback :state="validation">
                {{ invalid }}
            </b-form-invalid-feedback>
        </div>
    </div>
</template>

<script>
import workflowTaskMixins from "@/components/workflow/mixin/WorkflowTaskMixins";
import MiniMultiSelect from "@/components/workflow/stuffs/MiniMultiSelect";
import ImageUpload from "@/components/common/inputs/ImageUpload.vue";
import MultiAttachment from "@/components/echarts-part/stuff/MultiAttachment.vue";
import QgEntityPick from "@/components/qg/QgEntityPick.vue";
import MiniDateRange from "@/components/common/inputs/MiniDateRange.vue";

export default {
    name: "DiverseInput",
    components: {
        MiniDateRange,
        QgEntityPick, ImageUpload, MultiAttachment, MiniMultiSelect
    },
    mixins: [workflowTaskMixins],
    model: {
        prop: 'value',
        event: 'update'
    },
    props: {
        config: {
            type: Object,
            required: true,
        },
        value: {
            required: true
        },
        //only checkbox
        disabled: {
            type: Boolean,
            default: false
        },
        horizontal: {
            type: Boolean,
            default: false
        },
        noLabelWidthRate: Boolean,
        labelWidthRate: {
            type: Number,
            default: 3
        },
        withoutLabel: {
            type: Boolean,
            default: false
        },
        invalidShow: String,
        delayUpdate: {
            type: Boolean,
            default: false
        },
        action: {
            type: String,
            default: process.env.VUE_APP_EM_ADMIN_URL + "/emAttachment/uploads"
        },
        currentRow: Object,
    },
    data() {
        return {
            tempValue: null,
            tempTime: '00:00:00',
            changed: false,
            visible: false
        }
    },
    watch: {
        tempValue() {
            this.whenTempValueChange();
        },
        tempTime() {
            this.whenTempValueChange();
        },
        value: {
            handler() {
                let temp = this.value;
                if (this.isType(this.VALUE_TYPE.DATETIME) || this.isType(this.VALUE_TYPE.DATE)) {
                    if (this.hasCode(this.value)) {
                        this.tempValue = String(this.value).substring(0, 10);
                        if (this.value.length > 11) {
                            this.tempTime = String(this.value).substring(11);
                        }
                    }
                } else if (this.isType(this.VALUE_TYPE.COLOR)) {
                    this.tempValue = this.hasCode(this.value) ? this.value : '#ffffff';
                } else if (this.isType(this.VALUE_TYPE.SELECT_MULTI)) {
                    if (temp) {
                        // 兼容数组/非字符串输入：select-multi 统一以逗号分隔字符串处理
                        let split = (Array.isArray(temp) ? temp : String(temp).split(','));
                        let tempList = [];
                        for (let s of split) {
                            for (let item of this.options) {
                                if (item instanceof Object && item.value + '' === s) {
                                    tempList.push(item.text);
                                    break;
                                } else if (typeof item === 'string' && item === s) {
                                    tempList.push(item);
                                    break;
                                }
                            }
                        }
                        temp = tempList.join(",");
                    }
                    this.tempValue = temp;
                } else {
                    this.tempValue = this.value;
                }
                if (this.config.changeTag !== undefined) {
                    this.$emit('tagChange', this.config.changeTag(this.value));
                }
            },
            immediate: true
        }
    },
    computed: {
        require() {
            if (this.tempValue) {
                //
            }
            return this.config.require === true;
        },
        validation() {
            if (this.require) {
                return this.hasCode(this.value);
            }
            return this.config.validation === undefined ? null : this.config.validation(this.value);
        },
        valid() {
            return this.require || this.config.valid === undefined ? null : this.config.valid;
        },
        invalid() {
            return this.require || this.config.invalid === undefined ? '不能为空' : this.config.invalid;
        },
        options() {
            if (this.config.optionsFromDict) {
                if (this.$store.state.dictionaryEnumStore.reloadFlag) {
                    //
                }
                let ops = this.$store.getters['dictionaryEnumStore/getOptions'](this.config.optionsFromDict);
                if (this.config.selectDictText) {
                    let tempList = [];
                    for (let item of ops) {
                        tempList.push(item.text);
                    }
                    return tempList;
                }
                return ops;
            }
            let options = this.config.options;
            if (options instanceof Function && this.currentRow) {
                options = options(this.currentRow);
            }
            return options;
        },
    },
    mounted() {
        this.visible = this.require;//直接用require就不行，离了天下之大谱
        let initValue = this.config.initValue;
        if (initValue !== undefined && !this.hasCode(this.tempValue)) {
            this.tempValue = initValue;
            this.$forceUpdate()
        }
    },
    methods: {
        true2Null(val) {
            if (this.invalidShow) {
                return false;
            }
            if (!this.changed) {
                return null;
            }
            return val;
            // return val === true ? null : val;
        },
        isValidated() {
            return this.validation !== false;
        },
        whenTempValueChange(delay = false) {
            let temp = this.tempValue;
            if (this.hasCode(this.tempValue)) {
                if (this.tempTime == null) {
                    this.tempTime = '00:00:00';
                }
                if (this.isType(this.VALUE_TYPE.DATETIME) || this.isType(this.VALUE_TYPE.DATE)) {
                    temp += " " + this.tempTime;
                }
            } else {
                this.tempTime = null;
            }
            if (this.isType(this.VALUE_TYPE.SELECT_MULTI)) {
                if (temp) {
                    let split = temp.split(',');
                    let tempList = [];
                    for (let s of split) {
                        for (let item of this.options) {
                            if (item instanceof Object && item.text === s) {
                                tempList.push(item.value);
                                break;
                            } else if (typeof item === 'string' && item === s) {
                                tempList.push(item);
                                break;
                            }
                        }
                    }
                    temp = tempList.join(",");
                }
            }
            if (this.delayUpdate && !delay) {
                return;
            }
            this.$emit('update:value', temp);
            this.$emit('change', temp);
        },
        hasChanged() {
            this.changed = true;
            this.whenTempValueChange(true);
        },
        emitFocusEvent() {
            this.$emit('focus');
        },
        emitEnterEvent() {
            this.hasChanged();
            setTimeout(() => this.$nextTick(() => this.$emit('enter')), 500);
        },
        focus() {
            this.$refs.myInput.focus();
        },
        whenUploadSuccess(ids) {
            this.tempValue = ids.join(",");
        },
        whenAttachmentChange(ids) {
            this.tempValue = ids;
        },

        getMultiSelectOptions() {
            let tempList = [];
            for (let item of this.options) {
                if (item instanceof Object) {
                    tempList.push(item.text);
                } else if (typeof item === 'string') {
                    tempList.push(item);
                }
            }
            return tempList;
        },
        test() {
            console.log('1111')
        },
    }
}
</script>

<style scoped>
textarea {
    font-size: 0.79rem !important;
    margin: 0 !important;
}

.time-cover {
    overflow: hidden;
}

.time-cover >>> label {
    white-space: nowrap !important;
}
</style>
<style>
label.custom-control-label {
    width: 100% !important;
}
</style>
